import mdcImageList from './mdc-image-list.vue'
import mdcImageListItem from './mdc-image-list-item.vue'
export const mdcImageListComponents = {
  mdcImageList,
  mdcImageListItem,
}